// \src\components\TrackItem.tsx
'use client';

import React from 'react';
import styles from './TrackItem.module.css';
import { useAudioPlayer } from '@/context/AudioPlayerContext';
import ShareMenuButton from '@/components/ShareMenuButton';

interface Track {
  id: number;
  title: string;
  composer: string;
  duration: string;
  imageUrl?: string;
  slug: string;
  isFavorited?: boolean;
}

interface Props {
  track: Track;
  index: number;
  draggable?: boolean;   // 👈 новый проп
  isDragging?: boolean;
  playlistId?: number;   // 👈 добавляем
  isOwner?: boolean;     // 👈 добавляем
  onRemove?: (songId: number) => void;
}

export default function TrackItem({
  track,
  index,
  playlistId,
  isOwner,
  draggable = false,
  onRemove,
}: Props) {
  const { playTrack, currentTrack, isPlaying, pause, setIsPlaying } = useAudioPlayer();

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.defaultPrevented) return;
    if (draggable) return;

    // нормализуем трек перед запуском
    const normalizedTrack = {
      ...track,
      slug: track.slug,
      audioUrl: `/api/audio/${track.slug}/${track.slug}.m3u8`,
    };

    if (!currentTrack || currentTrack.id !== track.id) {
      playTrack(normalizedTrack);
      setIsPlaying(true);
    } else {
      if (isPlaying) {
        pause();
      } else {
        setIsPlaying(true);
      }
    }
  };


  return (
    <div
      className={`${styles.trackItem} 
        ${isPlaying && currentTrack?.id === track.id ? styles.active : ''} 
        ${index % 2 === 0 ? styles.odd : styles.even}
        ${draggable ? styles.draggable : ''}`}
      onClick={handleClick}
    >
      <div className={styles.index}>
        {draggable && (
          <span
            className={styles.dragHandle}
            onPointerDown={(e) => e.stopPropagation()}
          >
            ⋮⋮
          </span>
        )}

        {currentTrack?.id === track.id && isPlaying ? (
          <img src="/icons/pause-small-new.png" alt="Pause" width={16} height={16} />
        ) : (
          <>
            <span className={styles.indexNumber}>{index + 1}</span>
            {!draggable && (
              <span className={styles.iconHover}>
                <img src="/icons/play-small-new.png" alt="Play" width={16} height={16} />
              </span>
            )}
          </>
        )}
      </div>

      <div className={styles.trackInfo}>
        <div className={styles.trackTitle}>{track.title}</div>
        <div className={styles.trackComposer}>{track.composer}</div>
      </div>

      <div className={styles.trackMeta}>
        <span className={styles.duration}>{track.duration}</span>
        <ShareMenuButton
          item={track}
          type="song"
          playlistId={playlistId}
          isOwner={isOwner}
          onRemoved={() => onRemove?.(track.id)}
          onPointerDown={(e) => e.stopPropagation()}
          onClick={(e) => e.stopPropagation()}
        />
      </div>
    </div>
  );
}
